module.exports = __webpack_public_path__ + "img/EmptyCircle.6e02474e.png";